import $ from 'jquery';
import _ from './underscore_extend';

import {View} from 'backbone';

import Application from './application';

var settings = _.extract('Settings.Geowidgets'),
    initializeGeowidgets = function() {
        if (!settings) {
            return;
        }
        settings.Event = 'geowidgets.init';
        settings.EventDisplayed = 'geowidgets.displayed';

        var GeowidgetView = View.extend({
            initialize: function() {
                if (this.cookieIsEnabled() && this.cookieIsEmpty()) {
                    var url = this.getUrl();
                    var data = this.getData();

                    $.getJSON(url, data, _.bind(this.render, this));
                }
            },

            cookieIsEnabled: function() {
                return navigator.cookieEnabled;
            },
            cookieIsEmpty: function() {
                return !this.getCookie();
            },

            getUrl: function() {
                return settings.URL + '?json_callback=?';
            },
            getData: function() {
                var data = {
                        'template': this.name
                    },
                    i,
                    key,
                    query;

                for (i in settings.PASS_THROUGH_PARAMETERS) {
                    key = settings.PASS_THROUGH_PARAMETERS[i];
                    query = URI.parseQuery(window.location.search);
                    if (key in query) {
                        data[key] = query[key];
                    }
                }
                return data;
            },

            setCookie: function() {
                var cookieName = settings.COOKIE_PREFIX + this.name,
                    expiresDate = new Date(),
                    options;

                expiresDate.setTime(expiresDate.getTime() + settings.COOKIE_MAX_AGE * 1000);
                options = {
                    expires: expiresDate,
                    path: '/'
                };
                // TODO: check if domain-related magic is needed; it's possible cookie should be set only for current domain
                $.cookie(cookieName, true, options);
            },
            getCookie: function() {
                var cookieName = settings.COOKIE_PREFIX + this.name;

                return $.cookie(cookieName);
            },

            bindClose: function() {
                this.content.find('.js-widget-close').bind('click', _.bind(this.close, this));
            }
        });

        var GeowidgetPopupView = GeowidgetView.extend({
            name: 'popup',

            render: function(data) {
                this.setCookie();
                this.initContent(data.content);
                this.initDialog();
                this.bindClose();

                window.addEventListener('resize', () => {
                    this.content.dialog("option", "position", { my: "center", at: "center", of: window });
                });
                
                Application.trigger(settings.EventDisplayed, {
                    'widget': this.name
                });

                return this;
            },

            initContent: function(content) {
                var container = $('body');

                this.content = $(content);
                container.append(this.content);
            },
            initDialog: function() {
                this.content.dialog({
                    create: function (event, ui) {
                        $('.ui-widget-header').hide();
                    },
                    autoOpen: true,
                    resizable: false,
                    modal: true,
                    width: this.content.data('ui-dialog-width'),
                    dialogClass: 'js-geowidget-popup-dialog cluster ui-dialog__geowidget'
                });
            },

            close: function() {
                this.content.dialog('close');
                return false;
            }
        });

        var GeowidgetPopoutView = GeowidgetView.extend({
            name: 'popout',

            render: function(data) {
                this.initContent(data.content);
                this.bindClose();
                return this;
            },

            initContent: function(content) {
                var container = $('.js-header-content');

                this.content = $(content);
                container.append(this.content);
            },

            close: function() {
                this.setCookie();
                this.content.hide();
                return false;
            }
        });

        var dispatcher = function(geowidgetName) {
            var geowidgets = {
                'popup': GeowidgetPopupView,
                'popout': GeowidgetPopoutView
            };

            try {
                new geowidgets[geowidgetName]();
            } catch(e) {}
        };

        Application.on(settings.Event, dispatcher);

        Application.on(settings.EventDisplayed, (options = {}) => {
            if (options.widget !== 'popup') {
                return;
            }

            const {dialog, overlay} = settings.UI || {};
            if (dialog) {
                const widgetDialog = $('.js-geowidget-popup-dialog');
                widgetDialog.addClass(dialog);
            }
            if (overlay) {
                const widgetOverlay = $('.ui-widget-overlay');
                widgetOverlay.addClass(overlay);
            }
        });
        if (settings.POPUP_ENABLED) {
            Application.trigger(settings.Event, 'popup');
        }
        if (settings.POPOUT_ENABLED) {
            Application.trigger(settings.Event, 'popout');
        }
};

export default initializeGeowidgets;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/geowidgets.js